const RobotMascot = ({ className = "w-16", dark = false }) => {
  const line = dark ? "rgba(255,255,255,0.92)" : "#0A1628";
  const body = dark ? "rgba(255,255,255,0.06)" : "#FFFFFF";
  const visor = dark ? "#0B1B33" : "#0B1B33";
  return (
    <svg viewBox="0 0 140 140" fill="none" className={className} aria-hidden="true">
      {/* antenna */}
      <line x1="70" y1="14" x2="70" y2="27" stroke={line} strokeWidth="3" strokeLinecap="round" />
      <circle cx="70" cy="9" r="7" fill="#14D8A5" opacity="0.35" className="lr-halo" />
      <circle cx="70" cy="9" r="4" fill="#14D8A5" />
      {/* ears */}
      <rect x="30" y="40" width="8" height="16" rx="4" fill={dark ? "#14D8A5" : "#D7E5F0"} />
      <rect x="102" y="40" width="8" height="16" rx="4" fill={dark ? "#14D8A5" : "#D7E5F0"} />
      {/* head */}
      <rect x="37" y="27" width="66" height="42" rx="13" fill={body} stroke={line} strokeWidth="2.5" />
      <rect x="46" y="37" width="48" height="23" rx="11.5" fill={visor} />
      <circle cx="61.5" cy="48.5" r="5.4" fill="#4DA3FF" className="lr-eye" />
      <circle cx="78.5" cy="48.5" r="5.4" fill="#4DA3FF" className="lr-eye" />
      <circle cx="63.2" cy="46.6" r="1.7" fill="#FFFFFF" />
      <circle cx="80.2" cy="46.6" r="1.7" fill="#FFFFFF" />
      {/* body */}
      <rect x="45" y="73" width="50" height="38" rx="11" fill={body} stroke={line} strokeWidth="2.5" />
      <circle cx="70" cy="90" r="7" fill="#14D8A5" opacity="0.25" />
      <circle cx="70" cy="90" r="4" fill="#14D8A5" />
      <line x1="57" y1="103" x2="83" y2="103" stroke={line} strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      {/* arms */}
      <rect x="30" y="76" width="12" height="24" rx="6" fill={body} stroke={line} strokeWidth="2.5" transform="rotate(12 36 88)" />
      <rect x="98" y="76" width="12" height="24" rx="6" fill={body} stroke={line} strokeWidth="2.5" transform="rotate(-12 104 88)" />
      {/* legs */}
      <rect x="53" y="113" width="12" height="14" rx="5" fill={body} stroke={line} strokeWidth="2.5" />
      <rect x="75" y="113" width="12" height="14" rx="5" fill={body} stroke={line} strokeWidth="2.5" />
    </svg>
  );
};

export default RobotMascot;
